<template>
  <div class="sendnotice">
    <el-card class="card">
      <div class="title"></div>

      <el-form
        :model="form"
        :rules="rules"
        ref="formref"
        label-width="150px"
        class="demo-form"
      >
        <el-form-item label="通知内容" prop="con">
          <el-input
            type="textarea"
            v-model="form.con"
            :autosize="{ minRows: 6 }"
          ></el-input>
        </el-form-item>

        <el-form-item label="通知部门" prop="people">
          <el-cascader
            class="cascader"
            v-model="form.people"
            placeholder="请选择"
            clearable
            :options="LvSuoList"
            :props="{ multiple: true }"
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button type="primary" @click="inputCase('formref')"
              >确认提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getLvSuo, noticeInsert } from '../../api/case'
export default {
  name: 'sendnotice',
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    return {
      form: {
        con: null,
        people: null
      },
      rules: {
        con: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        people: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur']
          }
        ]
      },
      LvSuoList: []
    }
  },
  mounted() {
    this.GetLvSuo()
  },

  methods: {
    inputCase(formref) {
      this.$refs[formref].validate((valid) => {
        if (valid) {
          var newpp = []
          this.form.people.forEach((v) => {
            if (v.length == 2) {
              newpp.push(v[1])
            } else {
              newpp.push(v[0])
            }
          })
          noticeInsert({
            con: this.form.con,
            people: newpp
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('发送成功！')
              this.$refs[formref].resetFields()
            } else {
              this.$message.error('发送失败！')
            }
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('请检查案件信息填写错误!')
        }
      })
    },
    GetLvSuo() {
      getLvSuo({})
        .then((res) => {
          // console.log('getLvSuo', res.data.data)
          this.LvSuoList = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.sendnotice {
  height: 100%;
  width: 100%;

  .demo-form {
    width: 50%;
    justify-content: center;
    align-items: center;
    margin-left: 25%;
  }
  .title {
    margin: 4% 0 4% 0;
  }

  ::v-deep .el-input__inner {
    width: 35vw;
  }
}
</style>